<template>
    <div class="row" v-if="isValid('CanViewCategory')">
        <div class="col-lg-12 col-sm-12 ml-auto mr-auto" >
            
            <div class="card"  v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                <div class="BorderBottom ml-2 mr-2 mt-3 mb-3">
                    <span class=" DayHeading">{{ $t('Categories.ProductCategoryList') }}</span>
                </div>
                <div class="card-body">
                    <div class="row" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                            <div class="form-group">
                                <label>{{ $t('Categories.SearchbyCategory') }}</label>
                                <div>
                                    <input type="text" class="form-control search_input" v-model="search" name="search" id="search" :placeholder="$t('Categories.Search')" />
                                    <span class="fas fa-search search_icon"></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-right' : 'text-left'">
                            <a v-if="isValid('CanAddCategory')" href="javascript:void(0)" class="btn btn-primary " style="margin-top:27px;" v-on:click="AddCategory"><i class="fa fa-plus"></i> {{ $t('Categories.AddNew') }} </a>
                            <router-link :to="'/ProductManagement'">
                                <a href="javascript:void(0)" class="btn btn-outline-danger " style="margin-top:27px;">  {{ $t('Categories.Close') }} </a>
                            </router-link>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <table class="table table-striped table-hover table_list_bg" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                <thead class="m-0">
                                    <tr>
                                        <th>#</th>
                                        <th v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" width="10%">
                                            {{ $t('Categories.Code') }}
                                        </th>
                                        <th v-if="english=='true'" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" width="20%">
                                            {{ $t('Categories.CategoryName') |englishLanguage }}
                                        </th>
                                        <th v-if="isOtherLang()" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" width="20%">
                                            {{ $t('Categories.CategoryNameAr') |arabicLanguage}}
                                        </th>

                                        <th v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-center' : 'text-center'" width="40%">
                                            {{ $t('Categories.Description') }}
                                        </th>
                                        <th v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" width="10%">
                                            {{ $t('Categories.Status') }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(details,index) in categorylist" v-bind:key="details.id">
                                        <td v-if="currentPage === 1">
                                            {{index+1}}
                                        </td>
                                        <td v-else>
                                            {{((currentPage*10)-10) +(index+1)}}
                                        </td>
                                        <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-if="isValid('CanEditCategory')">
                                            <strong>
                                                <a href="javascript:void(0)" v-on:click="EditCategoryInfo(details.id)">{{details.code}}</a>
                                            </strong>
                                        </td>
                                        <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-else>
                                            <strong>
                                               {{details.code}}
                                            </strong>
                                        </td>

                                        <td v-if="english=='true'" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">{{details.name}}</td>
                                        <td v-if="isOtherLang()" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">{{details.nameArabic}}</td>
                                        <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-center' : 'text-center'">{{details.description}}</td>

                                        <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">{{details.isActive==true?$t('Categories.Active'):$t('Categories.De-Active')}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="float-left">
                        <span v-if="currentPage===1 && rowCount === 0">  {{ $t('Pagination.ShowingEntries') }}</span>
                        <span v-else-if="currentPage===1 && rowCount < 10">  {{ $t('Pagination.Showing') }} {{currentPage}}  {{ $t('Pagination.to') }} {{rowCount}}  {{ $t('Pagination.of') }} {{rowCount}}  {{ $t('Pagination.entries') }}</span>
                        <span v-else-if="currentPage===1 && rowCount >= 11  "> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*10}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                        <span v-else-if="currentPage===1"> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*10}} of {{rowCount}} {{ $t('Pagination.entries') }}</span>
                        <span v-else-if="currentPage!==1 && currentPage!==pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*10)-9}} {{ $t('Pagination.to') }} {{currentPage*10}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                        <span v-else-if="currentPage === pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*10)-9}} {{ $t('Pagination.to') }} {{rowCount}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                    </div>
                    <div class="float-right">
                        <div class="overflow-auto" v-on:click="GetCategoryData()">
                            <b-pagination pills size="lg" v-model="currentPage"
                                          :total-rows="rowCount"
                                          :per-page="10"
                                          first-text="First"
                                          prev-text="Previous"
                                          next-text="Next"
                                          last-text="Last"></b-pagination>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <categorymodal :show="show"
                       :category="newCategory"
                       v-if="show"
                       @close="show = false"
                       @IsSave="IsSave"
                       :type="type" />
    </div>
    <div v-else> <acessdenied></acessdenied></div>
</template>
<script>
    import clickMixin from '@/Mixins/clickMixin'
    export default {
        mixins: [clickMixin],
        name: 'category',
        data: function () {
            return {
                arabic: '',
                english: '',
                searchQuery: '',
                show: false,
                type: '',
                search: '',
                currentPage: 1,
                pageCount: '',
                rowCount: '',
                categorylist: [

                ],
                newCategory: {
                    id: '',
                    code: '',
                    name: '',
                    nameArabic: '',
                    description: '',
                    purchaseAccount: '',
                    cOSQAccount: '',
                    inventoryAccount: '',
                    incomeAccount: '',
                    saleAccount: '',
                    isActive: true,
                    returnDays: 0,
                    isReturn: false,
                    isService: false,
                }

            }
        },
        //computed: {
        //    resultQuery: function () {
        //        var root = this;
        //        if (this.searchQuery) {
        //            return this.categorylist.filter((c) => {
        //                return root.searchQuery.toLowerCase().split(' ').every(v => c.name.toLowerCase().includes(v))
        //            })
        //        } else {
        //            return root.categorylist;
        //        }
        //    },
        //},
        watch: {
            search: function (val) {
                this.GetCategoryData(val, 1);
            }
        },

        methods: {
            ProductManagement: function () {
                this.$router.push('/ProductManagement')
            },

            ExportData: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                var path = '/Template/Category.csv'
                var ext = path.split('.')[1];
                root.$https.get('/Product/ExportData?filePath=' + path, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {






                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'file.' + ext);
                        document.body.appendChild(link);
                        link.click();
                    }

                });
            },
            IsSave: function () {

                this.GetCategoryData(this.search, this.currentPage);
            },
            getPage: function () {
                this.GetCategoryData(this.search, this.currentPage);
            },
            ImportdCsv: function () {
                this.$router.push('/ImportCategory')
            },
            AddCategory: function () {
                this.newCategory = {
                    id: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    name: '',
                    nameArabic: '',
                    description: '',
                    purchaseAccount: '',
                    cOSQAccount: '',
                    inventoryAccount: '',
                    incomeAccount: '',
                    saleAccount: '',
                    isActive: true,
                    isReturn: false,
                    isService: false,
                    returnDays: 0,

                }

                this.show = !this.show;
                this.type = "Add";
            },
            GetCategoryData: function () {
                var root = this;
                var url = '/Product/GetCategoryInformation?isActive=false' + '&pageNumber=' + this.currentPage + '&searchTerm=' + this.search;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get(url, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.categorylist = response.data.results.categories;
                        root.pageCount = response.data.pageCount;
                        root.rowCount = response.data.rowCount;
                        root.loading = false;
                    }
                    root.loading = false;
                });

            },
            EditCategoryInfo: function (id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Product/CategoryDetailsViaId?Id=' + id, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {

                        root.newCategory = {
                            id: id,
                            code: response.data.code,
                            name: response.data.name,
                            nameArabic: response.data.nameArabic,
                            description: response.data.description,
                            purchaseAccountId: response.data.purchaseAccountId,
                            cOGSAccountId: response.data.cogsAccountId,
                            inventoryAccountId: response.data.inventoryAccountId,
                            incomeAccountId: response.data.incomeAccountId,
                            saleAccountId: response.data.saleAccountId,
                            isActive: response.data.isActive,
                            returnDays: response.data.returnDays,
                            isReturn: response.data.isReturn,
                            isService: response.data.isService,
                        }

                        root.show = !root.show;
                        root.type = "Edit";
                    }
                });
            },
        },
        created: function () {
            this.$emit('input', this.$route.name);
        },
        mounted: function () {
            this.english = localStorage.getItem('English');
            this.arabic = localStorage.getItem('Arabic');
            this.GetCategoryData(this.search, 1);
        }
    }
</script>